import { useState } from "react";
import api from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Button } from "./ui/button";
import { Navigation } from "lucide-react";
import { TEMPLATES, trackUrl } from "../lib/messages";
import { shareToCustomer } from "../lib/phone";
import { toast } from "sonner";

// Usta: "Yoldayım" — tahmini varış süresi + isteğe bağlı canlı konum paylaşımı
export default function OnTheWayDialog({ open, onOpenChange, job, onDone }) {
  const [eta, setEta] = useState(20);
  const [share, setShare] = useState(true);
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      let pos = {};
      if (share && navigator.geolocation) {
        pos = await new Promise((res) => navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude }), () => res({}), { timeout: 6000, maximumAge: 60000 }));
      }
      const { data } = await api.post(`/jobs/${job.id}/on-the-way`, { eta_minutes: eta, ...pos });
      const url = trackUrl(data.token);
      onDone && onDone(data);
      onOpenChange(false);
      toast.success("Yola çıktığınız kaydedildi");
      shareToCustomer(job, TEMPLATES.yolda.build(job, url, "ServisPlus", eta));
    } catch (e) { toast.error(e.response?.data?.detail || "Kaydedilemedi"); }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="ontheway-dialog">
        <DialogHeader><DialogTitle className="flex items-center gap-2"><Navigation className="h-4 w-4 text-blue-600" />Yoldayım</DialogTitle>
          <DialogDescription>Müşteriye "usta yolda" mesajı ve canlı takip linki gönderilir.</DialogDescription></DialogHeader>
        <div className="text-sm font-medium">Tahmini varış süresi</div>
        <div className="flex gap-2 flex-wrap">{[10, 15, 20, 30, 45, 60].map((m) => <Button key={m} variant={eta === m ? "default" : "outline"} className={eta === m ? "bg-blue-600 hover:bg-blue-700" : ""} onClick={() => setEta(m)} data-testid={`eta-${m}`}>{m} dk</Button>)}</div>
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={share} onChange={(e) => setShare(e.target.checked)} /> Konumumu müşteriyle paylaş (yalnızca yolda olduğum süre boyunca, 30 dk)</label>
        <Button onClick={go} disabled={busy} className="bg-blue-600 hover:bg-blue-700" data-testid="ontheway-go">{busy ? "Kaydediliyor…" : "Yola çıktım ve müşteriye bildir"}</Button>
      </DialogContent>
    </Dialog>
  );
}
